<template>
  <div class="container-header">
    <!--左侧的title-->
    <div class="container-header-title">
      <img class="container-header-title__img" />
      <span class="container-header-title__span">江苏省农业农村厅数字工作平台</span>
    </div>
    <!--中间的内容,遍历生成菜单-->
    <div class="container-header-menu">
      <!--菜单内容，后续有了config的信息需要编写根据path获取对应的大菜单索引的方法-->
      <div class="container-header-menu__overall">
        <div class="container-header-menu__item" v-for="(menu, index) in menus" @click="redirect(menu)">
          <svg-icon :icon-class="menu.icon" />
          {{ menu.name }}
        </div>
      </div>
    </div>
    <!--右侧的退出-->
    <div class="container-settings">
      <div class="container-settings_message" @click="handleMessage">消息</div>
      <div class="container-settings_help" @click="handleHelp">系统帮助</div>
      <div class="container-settings_user" @click="handleLogout">退出登录</div>
    </div>
  </div>
</template>

<script>
// import { menus } from '../config';
export default {
  name: 'LayoutHeader',
  data() {
    return {
      // 菜单列表
      menus: [],
      // 右侧的点击用户弹出的下拉项
      userManager: [
        {
          command: 'logout',
          to: '',
          label: '退出',
        },
      ],
    };
  },
  created() {
    // 此处进行菜单列表的获取
    // this.menus = menus;
  },
  methods: {
    // 跳转界面
    redirect({ path }) {
      // 如果path中包含https则直接跳转，否则更换路由
      if (path.includes('http://')) {
        window.location.href = path;
      } else {
        this.$router.push(path);
      }
    },
    // 查看消息
    handleMessage() {
      console.log('在此填写消息相关代码');
    },
    // 系统帮助
    handleHelp() {
      console.log('在此编写系统帮助相关');
    },
    handleLogout() {
      this.$store.dispatch('LogOut').then((res) => {
        this.$notification.success({
          message: '成功',
          description: '退出成功',
        });
        this.$router.push({ path: '/login' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 普通状态下的背景颜色
$background-color_normal: url('./images/background.png');
// 高亮状态下的背景颜色
$background-color_emphasis: rgba(255, 255, 255, 0.2);
// 普通状态下的文字颜色
$font-color_normal: white;
// 高亮状态下的文字颜色
$font-color_emphasis: #0e63bd;

@mixin vertical_line {
  position: absolute;
  content: '';
  left: -16px;
  top: 2px;
  width: 1px;
  height: 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

@mixin icon {
  position: absolute;
  content: '';
  left: 0px;
  top: -2px;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

// 菜单容器
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $background-color_normal;
  background-size: 100% 100%;
  color: $font-color_normal;
  padding: {
    left: 24px;
    right: 16px;
  }
  // 左侧的图表与描述栏
  .container-header-title {
    position: relative;
    display: flex;
    align-items: center;
    // 前侧的图片
    .container-header-title__img {
    }
    // 图片后方的标题
    .container-header-title__span {
      font-size: 20px;
      letter-spacing: 1.67px;
    }
  }

  // 中间的菜单显示
  .container-header-menu {
    flex-grow: 1;
    .container-header-menu__overall {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      column-gap: 20px;
      .container-header-menu__item {
        color: $font-color-normal;
        display: flex;
        flex-direction: column;
        &:focus,
        &:hover {
          background: $background-color_emphasis;
        }
        &.is-active {
          border-bottom: 4px solid $background-color_emphasis;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          color: $background-color_emphasis;
        }
      }
    }
  }
  // 右侧的退出
  .container-settings {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    div {
      padding-left: 24px;
      position: relative;
      margin: 0px 16px;
      &::after {
        @include icon;
      }
    }
    .container-settings_message {
      &::after {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTP///////////////////////////////////////////////////////////0Q+7AIAAAAPdFJOUwC8eY8I5mw8TSvV8xgGWrBvkksAAADbSURBVDjLY2CgD5i8+j8K2GUJEb/8HwPYgsR55TElPl4ASjD//9iDavQJ+f8GQGo+mEQBzP9/Akn7j5jOkf8MJNb/wJTo/wUk9v/BlDj/G0j8/4Apwf9/MEiwhSYAWalhDFAmXKL+/3cGBvb//wugTLiE/v9PDAxM//8rQJmEdeC0Y/AFCc4YxBnnOFMJznSFMyVC064IRNARkXYZnCFsBxCbRR6R2mH5QwSuAZY/wIAJrAWoQQHdJfogLY6g6EMDIC3YNIC1YNMA1oJVA0gLVg2w5IMNgFMJDQAAwv3fbgA014IAAAAASUVORK5CYII=);
      }
    }
    .container-settings_help {
      &::before {
        @include vertical_line;
      }
      &::after {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////////9JyxnAAAAAYdFJOUwAO9N4J5fnQXSKAAnM+7GZNjzUZr7iexhNMhU4AAAIJSURBVEjHnVYJkoQgDERFARW8lf+/dAOCJnjsulRNTQkk6TSdAGPp4P2wFKaqTLEMPWe/jEzOuUUjn2X2sp3XZHewqZ/CNF3pd4haapVlSsta+Imya+72T35VtMobh59q99npun907gt58dXIwgUZ03lZWVu1t2h569Zksh+8GP1EhjawTCxG8CHUM30KMqkQqgnwi+z1fMCiPDJv4MsQ/0q2raQzgEpERjqIp/F57PRbgfnXgLoLLACgluKNA+fVAqidxRr4P/kcjZfQMHhRIf45nEft88kxZZM7psHb88Ed5YSpz7P9X5xYV5iN+TQafK0Mc+M8zzgDZY/UAh1W4SxmCJzjOchnwUJaAu7oLeesB0Tnjs3aHtMPq9v5JdzqgH0wYBgruZmAqPML4g9sIbLKbUUEzgEFkejCgEaNfOQ1KYaRANZAMzM4Z1dlJMKKeXVZGwYSedapKxOk6gxE92rgjmFliQGFRLrCammZNB4SSZq4dyrcSHSf9JJUa3DWzE7eK09TWpKDO4ZTqkhD+4Oj0jjwVxf3URpUfCj4du0dXnxU3kjJ9d3kfCmg6KwoLmFjAdESfRmxRJMm8Hx5xCaQtpm9cMqyv2YQ2kzayEIhlUlDPhvZTau8GpBWedOMU0i0GUNhfWz33y+U71fW90sRWhC+dg/wz9fu94v9+9PhH4+Tvzx/fgDJTjHDl1ag8wAAAABJRU5ErkJggg==);
      }
    }
    .container-settings_user {
      &::before {
        @include vertical_line;
      }
      &::after {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTP///////////////////////////////////////////////////////////////////////////////0qNmhgAAAAUdFJOUwD6wfEhRhZANZXmsN1ag6QMBdBvT2AhQQAAAZpJREFUSMfFVVmShSAMjIAIuIDL/c86jSNPRFBe1VRNvqJ2S5JOAtE/2WjM+A1eNtvWyApgu7Ad1m2wbqeypS3CRQ/YeiWscHpR+D3HRyOuBGHg8ewhkwfp38BPAknt/SmPH9TxEBGI1JBjeHzvKEcg198Zo8fPlCfQ7BkXXQS/4FPCzuBxrRjid1QmkEMeLCoodFX0RCAF7c/iLqgnPRMI1V2iz1y+ESQ/39j0gBzBH2GPhMBV7wSFOFxIealp7yWkPd0iyg+QDnL3iYrFKYS44ShVQ1AhdHS8rJpbTMvuIEFXQ3AoxO7wegLfHfSVqCEIdGho1a6G0IWGtfVltUXhcvYRToVyvZj56GWqlIv+q6tiilB+Ql8LK+IZZZ/ZKJuNtwDCe8sigaDDh8cGlEPo7XORsbmMn1myyKhFSrbImJFAk6x8f3GwQlSShYsmKfO57q/5+nWfEWpFVJu96SEQztasxSur0ZdTlG6KV9ZxKaJj9NgJ50Q3arO/6MttoNh2M/YsaXv89TCj24o+niwbOB+Ynar21V/bD/ZnHxnr1lemAAAAAElFTkSuQmCC);
      }
    }
  }
}
</style>
